import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React from 'react'
import MDTypography from 'components/MDTypography'
import { Grid } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import Paper from '@mui/material/Paper';
import MDButton from 'components/MDButton'
import Container from '@mui/material/Container';
import { Formik, Form, Field, ErrorMessage } from 'formik'
import MDInput from 'components/MDInput'
import MDBox from 'components/MDBox'
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useConfig } from "../../../config"
import { useMaterialUIController } from 'context'
function updateRate() {
    const [controller] = useMaterialUIController()
    const { darkMode } = controller
    const { state } = useLocation()
    const { apiUrl, apiKey } = useConfig()
    const navigate = useNavigate();
    const adminToken = localStorage.getItem('gpay_admin_token')
    const initialValues = {
        usdtRate: state || '',
        notes: '',
    }
    const validationSchema = Yup.object({
        usdtRate: Yup.string().required('USDT Rate is required'),
        notes: Yup.string(),
    });
    const handleCancelClick = () => {
        // Go back to the previous page
        navigate(-1);
    };
    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const response = await fetch(`${apiUrl}/admin/updateUsdtRate`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${adminToken}`,
                    'apikey': apiKey,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(values)
            });
            const res = await response.json();
            if (res.responseCode !== 200) {
                toast.error(res.responseMessage, {
                    position: "top-right",
                    autoClose: 2000, // Auto close the toast after 3 seconds
                    hideProgressBar: false,
                });
                return;
            }

            setSubmitting(false);
            toast.success(res.responseMessage, {
                position: "top-right",
                autoClose: 2000, // Auto close the toast after 3 seconds
                hideProgressBar: false,
            });
            navigate(-1)
        } catch (error) {
            // Display an error toast
            toast.error('An error occurred. Please try again later.', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
            });

            // Reset submitting state
            setSubmitting(false);
        }
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
                <Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, backgroundColor: darkMode ? '#344767' : 'white' }}>
                    <MDTypography variant="h6" gutterBottom mb={4}>
                        Update Exchange Rate
                    </MDTypography>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <MDBox mb={2}>
                                            <Field type="text" label="USDT Rate" as={MDInput} fullWidth name="usdtRate" />
                                            <MDTypography color="error" variant="caption" >
                                                <ErrorMessage name="usdtRate" component="div" />
                                            </MDTypography>
                                        </MDBox>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <MDBox mb={2}>
                                            <Field type="text" label="Notes" as={MDInput} fullWidth name="notes" />
                                            <MDTypography color="error" variant="caption" >
                                                <ErrorMessage name="notes" component="div" />
                                            </MDTypography>
                                        </MDBox>
                                    </Grid>
                                </Grid>
                                <MDBox mt={4} mb={1} justifyContent="right">
                                    <Grid container justifyContent="right">
                                        <Grid item display={'flex'}>
                                            <MDBox>
                                                <MDButton
                                                    variant="gradient"
                                                    color="info"
                                                    type="submit"
                                                    disabled={isSubmitting}
                                                >
                                                    {isSubmitting ? 'Saving...' : 'Save'}
                                                </MDButton>
                                            </MDBox>
                                            <MDBox ml={2}>
                                                <MDButton
                                                    variant="gradient"
                                                    color="error"
                                                    onClick={handleCancelClick}
                                                >
                                                    Cancel
                                                </MDButton>
                                            </MDBox>
                                        </Grid>
                                    </Grid>
                                </MDBox>
                            </Form>
                        )}
                    </Formik>
                </Paper>
            </Container>
        </DashboardLayout>
    )
}

export default updateRate